// Generated by brand/scripts/web.mjs from the vectors in brand/src. Rebuild there rather than editing this file.
import { type ReactNode, type SVGProps } from "react";

const SMALL_BELOW = 48;

// The full mark from 48 px up; below that, one course over one heavy chevron row, so the frieze stays legible.
const MARKS = {
  full: {
    width: 1000,
    height: 978.39,
    outline:
      "M152 0H848A152 152 0 0 1 1000 152V655.4A152 152 0 0 1 848 807.4H416.4L203 978.4L203 807.4H152A152 152 0 0 1 0 655.4V152A152 152 0 0 1 152 0ZM152 54H848A98 98 0 0 1 946 152V655.4A98 98 0 0 1 848 753.4H397.5L257 865.9L257 753.4H152A98 98 0 0 1 54 655.4V152A98 98 0 0 1 152 54Z",
    frieze:
      "M114 114L886 114L886 155L114 155ZM114 652.4L886 652.4L886 693.4L114 693.4ZM131.9 196L284.4 196L208.1 298.9ZM423.8 196L576.2 196L500 298.9ZM715.6 196L868.1 196L791.9 298.9ZM114 265.9L208.1 393L354.1 196L500 393L645.9 196L791.9 393L886 265.9L886 334.8L791.9 461.9L645.9 264.9L500 461.9L354.1 264.9L208.1 461.9L114 334.8ZM114 415.4L208.1 542.5L354.1 345.5L500 542.5L645.9 345.5L791.9 542.5L886 415.4L886 484.3L791.9 611.4L645.9 414.4L500 611.4L354.1 414.4L208.1 611.4L114 484.3Z",
  },
  small: {
    width: 1000,
    height: 1121.08,
    outline:
      "M230 0H770A230 230 0 0 1 1000 230V661.1A230 230 0 0 1 770 891.1H505.4L250 1121.1L250 891.1H230A230 230 0 0 1 0 661.1V230A230 230 0 0 1 230 0ZM230 125H770A105 105 0 0 1 875 230V661.1A105 105 0 0 1 770 766.1H457.5L375 840.3L375 766.1H230A105 105 0 0 1 125 661.1V230A105 105 0 0 1 230 125Z",
    frieze:
      "M219 219L781 219L781 319L219 319ZM219 442.3L329.2 539L500 389L670.8 539L781 442.3L781 575.3L670.8 672.1L500 522.1L329.2 672.1L219 575.3Z",
  },
};

// Flag colours on a white badge: rows B G Y R B on the full mark, G Y R on the small colour cut.
// The outline stays in currentColor; the badge and rows are fixed, so the frieze never changes with the theme.
const COLOUR_MARKS = {
  full: {
    width: 1000,
    height: 978.39,
    silhouette:
      "M152 0H848A152 152 0 0 1 1000 152V655.4A152 152 0 0 1 848 807.4H416.4L203 978.4L203 807.4H152A152 152 0 0 1 0 655.4V152A152 152 0 0 1 152 0Z",
    outline:
      "M152 0H848A152 152 0 0 1 1000 152V655.4A152 152 0 0 1 848 807.4H416.4L203 978.4L203 807.4H152A152 152 0 0 1 0 655.4V152A152 152 0 0 1 152 0ZM152 54H848A98 98 0 0 1 946 152V655.4A98 98 0 0 1 848 753.4H397.5L257 865.9L257 753.4H152A98 98 0 0 1 54 655.4V152A98 98 0 0 1 152 54Z",
    rows: [
      {
        fill: "#111111",
        d: "M114 114L886 114L886 155L114 155Z",
      },
      {
        fill: "#319208",
        d: "M131.9 196L284.4 196L208.1 298.9ZM423.8 196L576.2 196L500 298.9ZM715.6 196L868.1 196L791.9 298.9Z",
      },
      {
        fill: "#FFD200",
        d: "M114 265.9L208.1 393L354.1 196L500 393L645.9 196L791.9 393L886 265.9L886 334.8L791.9 461.9L645.9 264.9L500 461.9L354.1 264.9L208.1 461.9L114 334.8Z",
      },
      {
        fill: "#DE2010",
        d: "M114 415.4L208.1 542.5L354.1 345.5L500 542.5L645.9 345.5L791.9 542.5L886 415.4L886 484.3L791.9 611.4L645.9 414.4L500 611.4L354.1 414.4L208.1 611.4L114 484.3Z",
      },
      {
        fill: "#111111",
        d: "M114 652.4L886 652.4L886 693.4L114 693.4Z",
      },
    ],
  },
  small: {
    width: 1000,
    height: 1177.16,
    silhouette:
      "M230 0H770A230 230 0 0 1 1000 230V717.2A230 230 0 0 1 770 947.2H505.4L250 1177.2L250 947.2H230A230 230 0 0 1 0 717.2V230A230 230 0 0 1 230 0Z",
    outline:
      "M230 0H770A230 230 0 0 1 1000 230V717.2A230 230 0 0 1 770 947.2H505.4L250 1177.2L250 947.2H230A230 230 0 0 1 0 717.2V230A230 230 0 0 1 230 0ZM230 125H770A105 105 0 0 1 875 230V717.2A105 105 0 0 1 770 822.2H457.5L375 896.4L375 822.2H230A105 105 0 0 1 125 717.2V230A105 105 0 0 1 230 125Z",
    rows: [
      {
        fill: "#319208",
        d: "M205 205L795 205L795 295L205 295Z",
      },
      {
        fill: "#FFD200",
        d: "M205 399.1L320.7 483L500 353L679.3 483L795 399.1L795 510.3L679.3 594.2L500 464.2L320.7 594.2L205 510.3Z",
      },
      {
        fill: "#DE2010",
        d: "M205 652.2L795 652.2L795 742.2L205 742.2Z",
      },
    ],
  },
};

function MarkPaths({ colour, small }: { colour: boolean; small: boolean }) {
  if (colour) {
    const m = small ? COLOUR_MARKS.small : COLOUR_MARKS.full;
    return (
      <>
        <path d={m.silhouette} fill="#FFFFFF" />
        <path d={m.outline} fillRule="evenodd" />
        {m.rows.map((row) => (
          <path key={row.d} d={row.d} fill={row.fill} />
        ))}
      </>
    );
  }
  const m = small ? MARKS.small : MARKS.full;
  return (
    <>
      <path d={m.outline} fillRule="evenodd" />
      <path d={m.frieze} />
    </>
  );
}

const WORDMARK = {
  x: 4,
  y: -726.6,
  width: 5199,
  height: 1067.8,
  d: "M237,14v0c-30,0 -59.5,-4 -88.5,-12c-29,-8 -56,-18.8 -81,-32.5c-25,-13.7 -46.2,-29.5 -63.5,-47.5v0l95,-97c16,16.7 35.2,29.7 57.5,39c22.3,9.3 46.2,14 71.5,14v0c14.7,0 25.8,-2 33.5,-6c7.7,-4 11.5,-9.7 11.5,-17v0c0,-10.7 -5.5,-18.8 -16.5,-24.5c-11,-5.7 -25.3,-10.7 -43,-15c-17.7,-4.3 -36.2,-9.7 -55.5,-16c-19.3,-6.3 -38,-14.8 -56,-25.5c-18,-10.7 -32.5,-25.7 -43.5,-45c-11,-19.3 -16.5,-44 -16.5,-74v0c0,-31.3 8.5,-58.8 25.5,-82.5c17,-23.7 40.8,-42.3 71.5,-56c30.7,-13.7 66.7,-20.5 108,-20.5v0c42,0 82,7.2 120,21.5c38,14.3 68.7,35.8 92,64.5v0l-96,97c-16,-18 -33.7,-30.5 -53,-37.5c-19.3,-7 -37,-10.5 -53,-10.5v0c-15.3,0 -26.3,2.2 -33,6.5c-6.7,4.3 -10,10.2 -10,17.5v0c0,8.7 5.5,15.7 16.5,21c11,5.3 25.3,10.2 43,14.5c17.7,4.3 36,9.8 55,16.5c19,6.7 37.3,15.8 55,27.5c17.7,11.7 32,27.2 43,46.5c11,19.3 16.5,44.3 16.5,75v0c0,48.7 -18.7,87.2 -56,115.5c-37.3,28.3 -87.3,42.5 -150,42.5zM1003,0h-174v-276c0,-22.7 -6.7,-40.5 -20,-53.5c-13.3,-13 -30.3,-19.5 -51,-19.5c-14,0 -26.5,3 -37.5,9c-11,6 -19.5,14.3 -25.5,25c-6,10.7 -9,23.7 -9,39v276h-174v-644.4l174,-82.3v266.6c7.3,-5.3 15.3,-10.7 24,-16c28.7,-15.3 62,-23 100,-23c39.3,0 73.5,7.8 102.5,23.5c29,15.7 51.3,37.2 67,64.5c15.7,27.3 23.5,59 23.5,95zM1326,11v0c-52.7,0 -99.5,-11.2 -140.5,-33.5c-41,-22.3 -73.5,-53 -97.5,-92c-24,-39 -36,-82.8 -36,-131.5v0c0,-48.7 11.8,-92.2 35.5,-130.5c23.7,-38.3 56.2,-68.7 97.5,-91c41.3,-22.3 88,-33.5 140,-33.5v0c52,0 98.5,11.2 139.5,33.5c41,22.3 73.5,52.7 97.5,91c24,38.3 36,81.8 36,130.5v0c0,48.7 -11.8,92.5 -35.5,131.5c-23.7,39 -56,69.7 -97,92c-41,22.3 -87.5,33.5 -139.5,33.5zM1325,-144v0c19.3,0 36.2,-4.2 50.5,-12.5c14.3,-8.3 25.5,-20.2 33.5,-35.5c8,-15.3 12,-33 12,-53v0c0,-20 -4.2,-37.5 -12.5,-52.5c-8.3,-15 -19.5,-26.7 -33.5,-35c-14,-8.3 -30.7,-12.5 -50,-12.5v0c-18.7,0 -35.3,4.3 -50,13c-14.7,8.7 -26,20.5 -34,35.5c-8,15 -12,32.5 -12,52.5v0c0,19.3 4,36.7 12,52c8,15.3 19.3,27.2 34,35.5c14.7,8.3 31.3,12.5 50,12.5zM2148,0h-174v-276c0,-22.7 -6.7,-40.5 -20,-53.5c-13.3,-13 -30.3,-19.5 -51,-19.5v0c-14,0 -26.5,3 -37.5,9c-11,6 -19.5,14.3 -25.5,25c-6,10.7 -9,23.7 -9,39v0v276h-174v-489h174v32c9.3,-6.7 19.3,-13 30,-19v0c30,-15.3 64.3,-23 103,-23v0c35.3,0 66.8,8.2 94.5,24.5c27.7,16.3 49.5,38.2 65.5,65.5c16,27.3 24,58.3 24,93v0zM2434,10v0c-45.3,0 -85.7,-11 -121,-33c-35.3,-22 -63,-52.2 -83,-90.5c-20,-38.3 -30,-81.8 -30,-130.5v0c0,-49.3 10,-93.3 30,-132c20,-38.7 47.7,-68.8 83,-90.5c35.3,-21.7 75.7,-32.5 121,-32.5v0c30.7,0 58.7,5.3 84,16v0c16,7.3 30,16 42,26v0v-32h171v489h-171v-33c-12,10 -26,18.7 -42,26v0c-25.3,11.3 -53.3,17 -84,17zM2471,-145v0c28.7,0 51.8,-9.3 69.5,-28c17.7,-18.7 26.5,-42.7 26.5,-72v0c0,-19.3 -4,-36.3 -12,-51c-8,-14.7 -19.2,-26.3 -33.5,-35c-14.3,-8.7 -30.8,-13 -49.5,-13c-18.7,0 -35.2,4.3 -49.5,13c-14.3,8.7 -25.7,20.5 -34,35.5c-8.3,15 -12.5,31.8 -12.5,50.5v0c0,19.3 4,36.5 12,51.5c8,15 19.3,26.8 34,35.5c14.7,8.7 31,13 49,13zM3009,14v0c-30,0 -59.5,-4 -88.5,-12c-29,-8 -56,-18.8 -81,-32.5c-25,-13.7 -46.2,-29.5 -63.5,-47.5v0l95,-97c16,16.7 35.2,29.7 57.5,39c22.3,9.3 46.2,14 71.5,14v0c14.7,0 25.8,-2 33.5,-6c7.7,-4 11.5,-9.7 11.5,-17v0c0,-10.7 -5.5,-18.8 -16.5,-24.5c-11,-5.7 -25.3,-10.7 -43,-15c-17.7,-4.3 -36.2,-9.7 -55.5,-16c-19.3,-6.3 -38,-14.8 -56,-25.5c-18,-10.7 -32.5,-25.7 -43.5,-45c-11,-19.3 -16.5,-44 -16.5,-74v0c0,-31.3 8.5,-58.8 25.5,-82.5c17,-23.7 40.8,-42.3 71.5,-56c30.7,-13.7 66.7,-20.5 108,-20.5v0c42,0 82,7.2 120,21.5c38,14.3 68.7,35.8 92,64.5v0l-96,97c-16,-18 -33.7,-30.5 -53,-37.5c-19.3,-7 -37,-10.5 -53,-10.5v0c-15.3,0 -26.3,2.2 -33,6.5c-6.7,4.3 -10,10.2 -10,17.5v0c0,8.7 5.5,15.7 16.5,21c11,5.3 25.3,10.2 43,14.5c17.7,4.3 36,9.8 55,16.5c19,6.7 37.3,15.8 55,27.5c17.7,11.7 32,27.2 43,46.5c11,19.3 16.5,44.3 16.5,75v0c0,48.7 -18.7,87.2 -56,115.5c-37.3,28.3 -87.3,42.5 -150,42.5zM3458,0h-174v-644.4l174,-82.3zM3754,10v0c-45.3,0 -85.7,-11 -121,-33c-35.3,-22 -63,-52.2 -83,-90.5c-20,-38.3 -30,-81.8 -30,-130.5v0c0,-49.3 10,-93.3 30,-132c20,-38.7 47.7,-68.8 83,-90.5c35.3,-21.7 75.7,-32.5 121,-32.5v0c30.7,0 58.7,5.3 84,16v0c16,7.3 30,16 42,26v0v-32h171v489h-171v-33c-12,10 -26,18.7 -42,26v0c-25.3,11.3 -53.3,17 -84,17zM3791,-145v0c28.7,0 51.8,-9.3 69.5,-28c17.7,-18.7 26.5,-42.7 26.5,-72v0c0,-19.3 -4,-36.3 -12,-51c-8,-14.7 -19.2,-26.3 -33.5,-35c-14.3,-8.7 -30.8,-13 -49.5,-13c-18.7,0 -35.2,4.3 -49.5,13c-14.3,8.7 -25.7,20.5 -34,35.5c-8.3,15 -12.5,31.8 -12.5,50.5v0c0,19.3 4,36.5 12,51.5c8,15 19.3,26.8 34,35.5c14.7,8.7 31,13 49,13zM4634,0h-174v-276c0,-22.7 -6.7,-40.5 -20,-53.5c-13.3,-13 -30.3,-19.5 -51,-19.5v0c-14,0 -26.5,3 -37.5,9c-11,6 -19.5,14.3 -25.5,25c-6,10.7 -9,23.7 -9,39v0v276h-174v-489h174v32c9.3,-6.7 19.3,-13 30,-19v0c30,-15.3 64.3,-23 103,-23v0c35.3,0 66.8,8.2 94.5,24.5c27.7,16.3 49.5,38.2 65.5,65.5c16,27.3 24,58.3 24,93v0zM4857,61.6c17,6.2 36.7,9.4 59,9.4c34.7,0 62.2,-8.5 82.5,-25.5c20.3,-17 30.5,-41.5 30.5,-73.5v-22c-8.7,6 -18.3,11 -29,15c-25.3,11.3 -53.3,17 -84,17c-45.3,0 -85.5,-10.5 -120.5,-31.5c-35,-21 -62.5,-49.8 -82.5,-86.5c-20,-36.7 -30,-77.7 -30,-123c0,-45.3 10,-86 30,-122c20,-36 47.5,-64.7 82.5,-86c35,-21.3 75.2,-32 120.5,-32c30.7,0 59,5.3 85,16c11.3,5.3 21.7,11.3 31,18v-24h171v455c0,52 -12.2,97.2 -36.5,135.5c-24.3,38.3 -57.5,68 -99.5,89c-32,16 -67.4,25.9 -106,29.7l-181.8,121l77.7,-230.1zM4948,-169c18.7,0 34.8,-4.2 48.5,-12.5c13.7,-8.3 24.2,-19.3 31.5,-33c7.3,-13.7 11,-28.5 11,-44.5c0,-16.7 -3.7,-31.7 -11,-45c-7.3,-13.3 -17.7,-24.2 -31,-32.5c-13.3,-8.3 -29.3,-12.5 -48,-12.5c-18,0 -33.8,4.2 -47.5,12.5c-13.7,8.3 -24.2,19.3 -31.5,33c-7.3,13.7 -11,28.5 -11,44.5c0,15.3 3.7,29.8 11,43.5c7.3,13.7 17.7,24.8 31,33.5c13.3,8.7 29,13 47,13z",
};

const TRADEMARK = {
  right: 5495,
  d: "M5393.5-598.8L5361.4-598.8L5361.4-726.6L5384.5-726.6L5428.4-660.8L5472-726.6L5495-726.6L5495-598.8L5463-598.8L5463-664L5438.8-627.6L5417.6-627.6L5393.5-664.4L5393.5-598.8ZM5314.3-598.8L5282.2-598.8L5282.2-698.9L5243-698.9L5243-726.6L5353.5-726.6L5353.5-698.9L5314.3-698.9L5314.3-598.8Z",
};

// Between the mark and the wordmark, as a share of the mark's width.
const GAP = 0.3;

// The ss monogram (merch spec 06), cropped to its ink. The letters follow the text colour; the chevrons don't.
const MONOGRAM = {
  x: 27.63,
  y: 20.48,
  width: 200.73,
  height: 215.05,
  letters:
    "M27.6,93c0,-28.9 23.5,-52.4 52.4,-52.4c10.1,0 19.6,2.9 27.6,7.8c-0.2,0.5 -0.4,1 -0.6,1.5c-2.1,4.7 -3.5,9.8 -4,15.1c-0.4,2.6 -0.6,5.2 -0.6,7.9c0,2.4 0.1,4.7 0.5,6.9l-6.3,3.7c-3.3,-5.7 -9.4,-9.5 -16.4,-9.5c-10.5,0 -19,8.5 -19,19c0,7 3.8,13.1 9.5,16.4l0,0l49.1,28.3l0,0c15.7,9.1 26.2,26 26.2,45.4c0,28.9 -23.5,52.4 -52.4,52.4c-19.4,0 -36.3,-10.5 -45.4,-26.2l29,-16.7c3.3,5.7 9.4,9.5 16.4,9.5c10.5,0 19,-8.5 19,-19c0,-7 -3.8,-13.1 -9.5,-16.4l0,0l-49.1,-28.3l0,0c-15.7,-9.1 -26.2,-26 -26.2,-45.4zM110.2,72.9c0,-28.9 23.5,-52.4 52.4,-52.4c19.4,0 36.3,10.5 45.4,26.2l-29,16.7c-3.3,-5.7 -9.4,-9.5 -16.4,-9.5c-10.5,0 -19,8.5 -19,19c0,7 3.8,13.1 9.5,16.4l0,0l6.2,3.6l6.1,22.9l-22.9,6.1l-6.2,-3.6l0,0c-15.7,-9.1 -26.2,-26 -26.2,-45.4zM202.2,117.6l0,0c15.7,9.1 26.2,26 26.2,45.4c0,28.9 -23.5,52.4 -52.4,52.4c-10.1,0 -19.6,-2.9 -27.6,-7.8c0.2,-0.5 0.4,-1 0.6,-1.5c2.1,-4.7 3.5,-9.8 4,-15.1c0.4,-2.6 0.6,-5.2 0.6,-7.9c0,-2.4 -0.1,-4.7 -0.5,-6.9l6.3,-3.7c3.3,5.7 9.4,9.5 16.4,9.5c10.5,0 19,-8.5 19,-19c0,-7 -3.8,-13.1 -9.5,-16.4l0,0l-9.1,-5.3l22.9,-6.1l-6.1,-22.9z",
  chevrons: [
    {
      fill: "#319208",
      d: "M169.8,118.3l-6.1,-22.9l5.5,3.2l6.1,22.9l-22.9,6.1l-5.5,-3.2z",
    },
    {
      fill: "#FFD200",
      d: "M179.6,123.9l-6.1,-22.9l5.5,3.2l6.1,22.9l-22.9,6.1l-5.5,-3.2z",
    },
    {
      fill: "#DE2010",
      d: "M189.4,129.6l-6.1,-22.9l5.5,3.2l6.1,22.9l-22.9,6.1l-5.5,-3.2z",
    },
  ],
};

type LogoProps = Omit<
  SVGProps<SVGSVGElement>,
  "children" | "viewBox" | "width" | "height"
> & {
  /**
   * "monogram" is the ss crest, for merch contexts only (the /wear page, merch avatars). It always keeps its
   * flag-colour chevrons and sits beside the wordmark or large enough to read: never a small one-colour mark.
   */
  variant?: "lockup" | "mark" | "wordmark" | "monogram";
  /** Height in px. Below 48 the mark switches to its small version. */
  size?: number;
  /** Flag colours on a white badge. false gives the one-colour mark in currentColor. */
  colour?: boolean;
  /** Adds ™ after the wordmark. */
  trademark?: boolean;
  /** Accessible name ("shonaslang", or "shonaslang monogram"). Pass "" when visible text already names the site. */
  title?: string;
};

export default function Logo({
  variant = "lockup",
  size = 32,
  colour = true,
  trademark = false,
  title,
  ...props
}: LogoProps) {
  const label =
    title ?? (variant === "monogram" ? "shonaslang monogram" : "shonaslang");
  const small = size < SMALL_BELOW;
  const mark = (colour ? COLOUR_MARKS : MARKS)[small ? "small" : "full"];
  const markPaths = <MarkPaths colour={colour} small={small} />;

  let viewBox: [number, number, number, number];
  let body: ReactNode;
  if (variant === "monogram") {
    viewBox = [MONOGRAM.x, MONOGRAM.y, MONOGRAM.width, MONOGRAM.height];
    body = (
      <>
        <path d={MONOGRAM.letters} />
        {MONOGRAM.chevrons.map((c) => (
          <path key={c.fill} fill={c.fill} d={c.d} />
        ))}
      </>
    );
  } else if (variant === "mark") {
    viewBox = [0, 0, mark.width, mark.height];
    body = markPaths;
  } else {
    const markWidth =
      variant === "lockup" ? (WORDMARK.height * mark.width) / mark.height : 0;
    const x = WORDMARK.x - markWidth * (variant === "lockup" ? 1 + GAP : 0);
    const right = trademark ? TRADEMARK.right : WORDMARK.x + WORDMARK.width;
    viewBox = [x, WORDMARK.y, right - x, WORDMARK.height];
    body = (
      <>
        {variant === "lockup" && (
          <svg
            x={x}
            y={WORDMARK.y}
            width={markWidth}
            height={WORDMARK.height}
            viewBox={`0 0 ${mark.width} ${mark.height}`}
          >
            {markPaths}
          </svg>
        )}
        <path d={WORDMARK.d} />
        {trademark && <path d={TRADEMARK.d} />}
      </>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox.join(" ")}
      height={size}
      width={+((size * viewBox[2]) / viewBox[3]).toFixed(2)}
      fill="currentColor"
      {...(label
        ? { role: "img", "aria-label": label }
        : { "aria-hidden": true })}
      {...props}
    >
      {body}
    </svg>
  );
}
